import { Stack, Typography } from '@mui/material'
import { IVesselVisitItem } from '@planning/rt-stores/vesselVisit/VesselVisitItem'
import { formatDateTime } from '@planning/utils'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'

export const VesselVisitLabel = ({ item }: { item: IVesselVisitItem }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  return (
    <Stack>
      <Typography fontWeight='bold'>{`${item.data.number} - ${item.vessels[0]?.data.name}`}</Typography>
      <Typography
        variant='caption'
        color={theme.palette.secondary.dark}
      >{`${t('ata', 'ATA')}: ${formatDateTime(item.data.ata)}`}</Typography>
    </Stack>
  )
}
